import { useState, useEffect } from 'react';

const useScroll = () => {
  const [scrollInfo, setScrollInfo] = useState({
    isEnd: false,
    scrollTop: 0,
  });

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop } = document.documentElement;
      const windowHeight = window.innerHeight;
      const { scrollHeight } = document.documentElement;
      const isEnd = scrollTop + windowHeight >= scrollHeight;

      setScrollInfo({
        isEnd,
        scrollTop,
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    isEnd: scrollInfo.isEnd,
    scrollTop: scrollInfo.scrollTop,
  };
};

export default useScroll;
